<template>
  <div class="bg-yellow-100">
    <slot />
    <p v-if="text" class="u-center p-4">{{ text }}</p>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    text: {
      type: String,
    },
  },
  setup() {},
});
</script>
